import { Alert } from "@mui/material";
import AlertIcon from "../../assets/img/alert.png";
import { useRoles } from "../../hooks/roles";

interface PropsAlert {
  text: string;
}
const InfoAlert = ({ text }: PropsAlert) => {

  const { isEngineer } = useRoles();

  return (
    <Alert
      icon={false}
      severity="info"
      sx={{
        background: "#FFDF95",
        color: "#000000",
        fontSize: 15,
        display: "flex",
        width: isEngineer? "92%" : "95%",
        marginBottom: "15px",
        marginTop: "10px",
        fontStyle: "italic",
        borderRadius: 0,
      }}
    >
      <div style={{ display: "flex" }}>
        <img
          className="icon-alert"
          src={AlertIcon}
          style={{ marginRight: 10, width: "24px", height: "24px" }}
          alt="alert-icon"
        />
        {text}
      </div>
    </Alert>
  );
};

export default InfoAlert;
